const couchUrlPrefix = process.env.VUE_APP_API_COUCH
console.log('couchUrlPrefix: ' + couchUrlPrefix)

import { getAsBool, getAsInt } from '@/functions/env'

const VUE_APP_MODULE_STAYS_ROOM_INTERNAL_ENABLED = getAsBool(
		'VUE_APP_MODULE_STAYS_ROOM_INTERNAL_ENABLED'
	), VUE_APP_MODULE_ZWR_ENABLED = getAsBool('VUE_APP_MODULE_ZWR_ENABLED'),
	VUE_APP_MODULE_DRUG_APPLICATION_INTERNAL_ENABLED = getAsBool('VUE_APP_MODULE_DRUG_APPLICATION_INTERNAL_ENABLED'),
	VUE_APP_MODULE_EXAMINATION_CREATE_CN_ENABLED = getAsBool('VUE_APP_MODULE_EXAMINATION_CREATE_CN_ENABLED'),
	VUE_APP_MODULE_PATOGENS_ENABLED = getAsBool('VUE_APP_MODULE_PATOGENS_ENABLED'),
	VUE_APP_MODULE_TREATMENTFORM_CREATE_CN_ENABLED = getAsBool('VUE_APP_MODULE_TREATMENTFORM_CREATE_CN_ENABLED'),
	VUE_APP_MODULE_TREATMENTFORM_EDIT_CN_ENABLED = getAsBool('VUE_APP_MODULE_TREATMENTFORM_EDIT_CN_ENABLED')

const common = {
	waitForLeadership: true,
	options: {
		live: false,
		retry: false,
		batches_limit: 999999,
		//timeout: 5 * 60 * 1000
		checkpoint: 'target',
	},
	direction: {
		// read only
		pull: true,
		push: false,
	},
	allowedRules: ['admin', 'doctor', 'personel_zwr', 'nurse'],
}

export const createRemote = function (tablename) {
		if (!couchUrlPrefix || couchUrlPrefix?.length == 0)
			throw new Error(
				`No couch url environment variable "VUE_APP_API_COUCH"`
			)

		let couchUrl = couchUrlPrefix + '/' + tablename

		if (couchUrl[0] === '/')
			couchUrl = `${window.location.origin}${couchUrl}`

		return couchUrl
	},
	kebabCaseToCamelCase = (string) =>
		string
			.replace(/(-[a-z])/g, (letters) => `${letters[1].toUpperCase()}`)
			.replace(/^[a-z]/g, (letters) => `${letters.toUpperCase()}`)

const getSyncConfig = function () {
	let baseSyncConfig = {
		stays: {
			modelName: 'stay',
			...common,
		},
		stay_notes: {
			modelName: 'stay-note',
			...common,
			direction: {
				pull: true,
				push: true,
			},
		},
		stay_note_files: {
			modelName: 'stay-note-file',
			...common,
			direction: {
				pull: true,
				push: true,
			},
		},
		stay_note_roles: {
			modelName: 'stay-note-role',
			...common,
			direction: {
				pull: true,
				push: true,
			},
		},
		patients: {
			modelName: 'patient',
			...common,
		},
		patient_profile_images: {
			modelName: 'patient-profile-image',
			...common,
			direction: {
				pull: true,
				push: true,
			},
		},
		patient_alerts: {
			modelName: 'patient-alert',
			...common,
		},
		alert_attributes: {
			modelName: 'alert-attribute',
			...common,
		},
		alert_attribute_codes: {
			modelName: 'alert-attribute-code',
			...common,
		},
		alert_attribute_levels: {
			modelName: 'alert-attribute-level',
			...common,
		},
		examinations: {
			modelName: 'examination',
			...common,
		},
		treatments: {
			modelName: 'treatment-form',
			...common,
		},
		procedures: {
			modelName: 'procedure',
			...common,
		},
		diagnosis: {
			modelName: 'stay-diagnosis',
			...common,
		},
		drug_applications: {
			modelName: 'drug-application',
			...common,
		},
		org_units: {
			modelName: 'org-unit',
			...common,
		},
		org_unit_persons: {
			modelName: 'org-unit-person',
			...common,
		},
		zwr_monitor_orders: {
			modelName: 'zwr-monitor-order',
			...common,
			direction: {
				pull: true,
				push: true,
			},
			allowedRules: ['admin', 'personel_zwr'],
		},
		zwr_patient_alerts: {
			modelName: 'zwr-patient-alert',
			...common,
			allowedRules: ['admin', 'personel_zwr'],
		},
		org_unit_room_stays: {
			modelName: 'org-unit-room-stay',
			...common,
			direction: {
				pull: true,
				push: true,
			},
		},
		org_unit_rooms: {
			modelName: 'org-unit-room',
			...common,
		},
		drug_application_internals: {
			modelName: 'drug-application-internal',
			...common,
			direction: {
				pull: true,
				push: true,
			},
		},
		pathogen_instances: {
			modelName: 'pathogen-instance',
			...common,
		},
		treatment_templates: {
			modelName: 'treatment-form-template',
			...common,
		},
		treatment_requests: {
			modelName: 'treatment-form-request',
			...common,
			direction: {
				pull: true,
				push: true,
			},
		},
		examination_requests: {
			modelName: 'examination-request',
			...common,
			direction: {
				pull: true,
				push: true,
			},
		},
		service_performing_units: {
			modelName: 'service-performing-unit',
			...common,
		},
		performing_units: {
			modelName: 'performing-unit',
			...common,
		},
		services: {
			modelName: 'service',
			...common,
		},
	}
	
	Object.keys(baseSyncConfig).forEach((collectionName) => {
		const batchSize = getAsInt(`VUE_APP_RXDB_BATCH_SIZE_${collectionName.toUpperCase()}`)
		
		if(!batchSize)
			throw new Error(`No batch size environment variable "VUE_APP_RXDB_BATCH_SIZE_${collectionName.toUpperCase()}"`)
		
		baseSyncConfig[collectionName].options.batch_size = batchSize
	})

	if (!VUE_APP_MODULE_STAYS_ROOM_INTERNAL_ENABLED) {
		delete baseSyncConfig.org_unit_room_stays
		delete baseSyncConfig.org_unit_rooms
	}
	
	if(!VUE_APP_MODULE_ZWR_ENABLED){
		delete baseSyncConfig.zwr_monitor_orders
		delete baseSyncConfig.zwr_patient_alerts
	}
	
	if(!VUE_APP_MODULE_DRUG_APPLICATION_INTERNAL_ENABLED){
		delete baseSyncConfig.drug_application_internals
	}
	
	if(!VUE_APP_MODULE_EXAMINATION_CREATE_CN_ENABLED){
		delete baseSyncConfig.examination_requests
		delete baseSyncConfig.service_performing_units
		delete baseSyncConfig.performing_units
		delete baseSyncConfig.services
	}
	
	if(!VUE_APP_MODULE_PATOGENS_ENABLED){
		delete baseSyncConfig.pathogen_instances
	}
	
	if(!VUE_APP_MODULE_TREATMENTFORM_CREATE_CN_ENABLED && !VUE_APP_MODULE_TREATMENTFORM_EDIT_CN_ENABLED){
		delete baseSyncConfig.treatment_templates
		delete baseSyncConfig.treatment_requests
	}

	return baseSyncConfig
}

export const syncConfig = getSyncConfig()

export default syncConfig
